package app.properties

import kotlin.js.Math
import kotlin.math.pow

data class Credit(
        var id: String? = null,
        var creditType: CreditType? = null,
        var currency: Currency? = null,
        var loanAmount: Float = 0F,
        var loanTime: Int = 12,
        var paymentPerMonth: Float = 0F,
        var guaranty: MutableList<String> =  mutableListOf(),
        var person: Person? =  null,
        var company: Company? = null,
        var document: MutableList<Document> = mutableListOf(),
        var other: String? =  null,
        var dataRight: Boolean = false,
        var agreeWithAcra: Boolean = false,
        var cdate: String? = null,
        var email: String? = null,
        var phones: MutableList<String> = mutableListOf(""),
        var hch: String = "",
        var percent: Float = 12F,
        var status: String = "",
        var hh: Int = 0
) {

    val telRegex = Regex("^\\+374 \\([0-9]{2}\\) [0-9]{2}\\-[0-9]{2}\\-[0-9]{2}")
    val hchRegex = Regex("^([0-9]{10})+$")

    fun calculatePaymentPerMonth(): String {

        val persentage = percent.div(100 * loanTime)
        val exponent = 0 - loanTime


        val paymentPerMonth = (loanAmount * persentage).div(1 - (1 + persentage).toDouble().pow(exponent.toDouble()))
        return if(paymentPerMonth > 0) "${paymentPerMonth.toInt()}" else ""
    }

    fun isValid(): Boolean {

        validatePhones()

        return (creditType!=null &&
                currency!=null &&
                loanAmount > 0 &&
                loanTime > 0 &&
                guaranty.size > 0 &&
                (company?.isValid() != null || person?.isValid() != null) &&
                (document.isNotEmpty() && document.all { it.isValid() }) &&
                dataRight &&
                agreeWithAcra &&
                (email == null || emailRegex.containsMatchIn(email ?: "")) &&
                (hch != "" && hchRegex.containsMatchIn(hch)) &&
                validatePhones())
    }

    fun validatePhones() : Boolean {

        val existsValidPhone = phones.filter {
            telRegex.containsMatchIn(it)
        }

        return existsValidPhone.isNotEmpty()
    }

    companion object {
        val emailRegex = Regex("^([a-zA-Z0-9_.+-])+\\@(([a-zA-Z0-9-])+\\.)+([a-zA-Z0-9]{2,4})+$")
    }
}